import React from 'react';
import { CTAButton } from '../CTAButton';
import { CountdownTimer } from '../CountdownTimer';
import { ScarcityBar } from '../ScarcityBar';
const badges = ['Instant Download', 'One-Time Payment', 'Lifetime Access', '7-Day Money-Back Guarantee'];
export function FinalCta() {
  return <section className="w-full bg-navy-950 px-4 py-14 sm:px-6 sm:py-20" data-id="element-114" data-mp="1snj8sxv1bluu">
      <div className="mx-auto w-full max-w-3xl" data-id="element-115" data-mp="1eob8g1n4y7p2">
        <p className="text-center font-display text-[15px] font-bold uppercase tracking-[0.14em] text-gold-500 sm:text-lg" data-id="element-116" data-mp="1eni9vnybyoi0">
          🔧 Technical System PRO 360™
        </p>
        <h2 className="mt-2 text-center font-display text-[32px] font-extrabold uppercase leading-[1.02] text-white sm:text-[48px]" data-id="element-117" data-mp="14qnaz3y5am37">
          Build a professional appliance repair business in{' '}
          <span className="text-gold-500" data-id="element-118" data-mp="2z3n1hs42d0p9">just one day</span>
        </h2>

        <div className="mt-5 space-y-2 text-center text-[15px] leading-relaxed text-white/80 sm:text-lg" data-id="element-119" data-mp="3437xbtnxssxr">
          <p data-id="element-120" data-mp="28v4w88sxqhq">You already know how to repair appliances.</p>
          <p className="font-semibold text-white" data-id="element-121" data-mp="27a9yhiks5jc">
            Now it’s time to learn how to operate the business behind those
            repairs.
          </p>
        </div>

        <div className="mt-7" data-id="element-122" data-mp="b0djwfu0i098">
          <CTAButton icon="🔥" label="Yes — I want it for $27" sub="Instant Download · One-Time Payment · Lifetime Access · 7-Day Guarantee" data-id="element-123" data-mp="b3j9dw6jz45h" />
        </div>

        <p className="mt-4 text-center text-[12px] font-medium text-white/60 sm:text-sm" data-id="element-124" data-mp="3fhr7691o574f">
          💱 Your currency is converted automatically based on your location.
        </p>

        <div className="mt-6" data-id="element-125" data-mp="3ohwd0er7rxgh">
          <CountdownTimer label="The promotional offer ends in" data-id="element-126" data-mp="3odyunvcgn9xn" />
        </div>

        <div className="mt-4" data-id="element-127" data-mp="3jjcqac4sqhn2">
          <ScarcityBar data-id="element-128" data-mp="13pu811almuzn" />
        </div>

        <div className="mt-10 rounded-2xl border-l-4 border-gold-500 bg-navy-900 px-4 py-5" data-id="element-129" data-mp="13osw6ulre4gv">
          <p className="font-display text-[22px] font-extrabold uppercase leading-[1.05] text-white sm:text-3xl" data-id="element-130" data-mp="ypzkn7q18njc">
            Stop working like a technician who owns a job.
          </p>
          <p className="mt-1 font-display text-[22px] font-extrabold uppercase leading-[1.05] text-gold-500 sm:text-3xl" data-id="element-131" data-mp="1bwodsejdkny">
            Start operating like a business owner.
          </p>
        </div>

        <div className="mt-6" data-id="element-132" data-mp="admcopd4g3hi">
          <CTAButton label="Get Technical System PRO 360™ now — $27" data-id="element-133" data-mp="acl4csnhpv3h" />
        </div>

        <ul className="mt-6 grid grid-cols-2 gap-2" data-id="element-134" data-mp="39tsr0g6wg54g">
          {badges.map(badge => <li key={badge} className="rounded-lg border border-white/10 bg-navy-900 px-2 py-2.5 text-center text-[12px] font-semibold leading-tight text-white/85 sm:text-sm" data-id="element-135" data-mp="3dv4jcth5r4gc">
              {badge}
            </li>)}
        </ul>
      </div>
    </section>;
}